import {readonly, ref} from 'vue'
import {Bank} from '@/bank/bank.types'
import {getCatching} from '@/bank/bankApi.service'
import {notifyError} from '@/services/infrastructure/notification.service'

const banks = ref<Bank[]>([])
const isInitialized = ref(false)

export const useBanks = () => {
    const fetchBanks = async () => {
        const result = await getCatching<Bank[]>('/banks')
        if (result.isLeft()) {
            notifyError({title: 'Kunne ikke hente banker', description: {descriptionMessage: result.error.detail, error: result.error}})
        } else {
            banks.value = result.value
        }
    }

    if (!isInitialized.value) {
        isInitialized.value = true
        fetchBanks()
    }

    return {
        banks: readonly(banks),
        fetchBanks
    }
}
